"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedComponent = exports.getLocalizedProps = void 0;
const React = __importStar(require("react"));
const ll_1 = require("./ll");
const localizableProps = [
    "label",
    "title",
    "text",
    "header",
    "placeholder",
    "message"
];
exports.getLocalizedProps = (props, languageId, propsToLocalize, localize, variables) => {
    const localizedProps = {};
    let shouldLocalize = localize;
    if (shouldLocalize === undefined) {
        shouldLocalize = true;
    }
    (propsToLocalize || localizableProps).forEach(propName => {
        if (props[propName] && typeof props[propName] === "string") {
            localizedProps[propName] = shouldLocalize
                ? ll_1.ll({
                    key: props[propName],
                    languageId,
                    variables
                })
                : props[propName];
        }
    });
    const { children, ...nonChildrenProps } = props;
    return { ...nonChildrenProps, ...localizedProps };
};
exports.LocalizedComponent = props => {
    const { children } = props;
    const { className, localize, ...otherProps } = props;
    return (React.createElement(ll_1.LLConsumer, null, ({ languageId }) => React.Children.only(React.cloneElement(children, {
        ...exports.getLocalizedProps(otherProps, props.language || languageId, undefined, props.localize, props.variables),
        dir: ll_1.isRTL(props.language || languageId) ? "rtl" : undefined
    }))));
};
//# sourceMappingURL=LocalizedComponent.js.map